document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector(".hz-review-slider");
  const prev = document.querySelector(".hz-prev");
  const next = document.querySelector(".hz-next");
  const dotsContainer = document.querySelector(".hz-dots");

  if (!slider) return;

  let cards = [...slider.querySelectorAll(".hz-review-card")];

  if (!cards.length) return;

  /* -----------------------------
      Infinite Loop
  ------------------------------*/

  const firstClone = cards[0].cloneNode(true);
  const lastClone = cards[cards.length - 1].cloneNode(true);

  slider.appendChild(firstClone);
  slider.insertBefore(lastClone, cards[0]);

  cards = [...slider.querySelectorAll(".hz-review-card")];

  const gap = parseInt(getComputedStyle(slider).gap) || 34;

  function cardWidth() {
    return cards[0].offsetWidth + gap;
  }

  let index = 1;

  slider.scrollLeft = cardWidth();

  /* -----------------------------
      Dots
  ------------------------------*/

  const total = cards.length - 2;
  let dots = [];

  if (dotsContainer) {
    for (let i = 0; i < total; i++) {
      const dot = document.createElement("button");
      dot.className = "hz-dot";
      if (i === 0) dot.classList.add("active");

      dot.onclick = () => {
        index = i + 1;
        goToSlide();
        restart();
      };

      dotsContainer.appendChild(dot);
    }

    dots = [...dotsContainer.querySelectorAll(".hz-dot")];
  }

  function updateDots() {
    if (!dots.length) return;

    dots.forEach((d) => d.classList.remove("active"));

    let active = index - 1;

    if (active < 0) active = total - 1;
    if (active >= total) active = 0;

    dots[active].classList.add("active");
  }

  function updateActiveCard() {
    cards.forEach((card) => card.classList.remove("active"));

    if (cards[index]) {
      cards[index].classList.add("active");
    }
  }

  function goToSlide() {
    slider.scrollTo({
      left: index * cardWidth(),
      behavior: "smooth",
    });

    updateDots();
    updateActiveCard();
  }

  /* -----------------------------
      Next & Prev Controls
  ------------------------------*/

  function nextSlide() {
    index++;
    goToSlide();
  }

  function prevSlide() {
    index--;
    goToSlide();
  }

  if (next) {
    next.onclick = () => {
      nextSlide();
      restart();
    };
  }

  if (prev) {
    prev.onclick = () => {
      prevSlide();
      restart();
    };
  }

  /* -----------------------------
      Infinite Reset
  ------------------------------*/

  slider.addEventListener("scrollend", () => {
    if (index === cards.length - 1) {
      slider.scrollLeft = cardWidth();
      index = 1;
    }

    if (index === 0) {
      slider.scrollLeft = cardWidth() * total;
      index = total;
    }

    updateDots();
  });

  /* -----------------------------
      Auto Play
  ------------------------------*/

  let auto;

  function start() {
    auto = setInterval(nextSlide, 4000);
  }

  function stop() {
    clearInterval(auto);
  }

  function restart() {
    stop();
    start();
  }

  slider.addEventListener("mouseenter", stop);
  slider.addEventListener("mouseleave", start);
  slider.addEventListener("touchstart", stop);
  slider.addEventListener("touchend", start);

  /* -----------------------------
      Drag
  ------------------------------*/

  let down = false;
  let startX;
  let scroll;

  slider.addEventListener("mousedown", (e) => {
    down = true;
    startX = e.pageX;
    scroll = slider.scrollLeft;
  });

  window.addEventListener("mouseup", () => (down = false));

  slider.addEventListener("mousemove", (e) => {
    if (!down) return;
    e.preventDefault();
    slider.scrollLeft = scroll - (e.pageX - startX);
  });

  /* -----------------------------
      Keyboard
  ------------------------------*/

  document.addEventListener("keydown", (e) => {
    if (e.key === "ArrowRight") {
      nextSlide();
      restart();
    }

    if (e.key === "ArrowLeft") {
      prevSlide();
      restart();
    }
  });

  updateDots();
  updateActiveCard();
  start();
});